import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IosRequiredDirective } from './ios-required.directive';

@NgModule({
  declarations: [IosRequiredDirective],
  imports: [CommonModule],
  exports: [IosRequiredDirective],
})
export class DirectivesModule {}
